import { render, staticRenderFns } from "./TestVideoModal.vue?vue&type=template&id=41891002&"
import script from "./TestVideoModal.vue?vue&type=script&lang=js&"
export * from "./TestVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports